/** Beat Shop GA4 events (features spec B12) — rides the existing consent-gated service. */
import { trackEvent } from '../../services/analytics/analytics.service';

export const trackBeatshopView = (tab: string) => trackEvent('beatshop_view', { tab });
export const trackBeatPreviewed = (beatId: string) => trackEvent('beat_previewed', { beat_id: beatId });
export const trackBeatFavorited = (beatId: string, favorited: boolean) =>
  trackEvent('beat_favorited', { beat_id: beatId, favorited: String(favorited) });
export const trackCheckoutStarted = (beatId: string, tender: string) =>
  trackEvent('checkout_started', { beat_id: beatId, tender });
export const trackPurchaseCompleted = (beatId: string, tender: string) =>
  trackEvent('purchase_completed', { beat_id: beatId, tender }); // activation milestone
export const trackBeatDownloaded = (beatId: string, fileKind: string) =>
  trackEvent('beat_downloaded', { beat_id: beatId, file_kind: fileKind });
export const trackBeatUploaded = (beatId: string) => trackEvent('beat_uploaded', { beat_id: beatId });
